import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { Observable } from 'rxjs';

export interface FamilyCase {
	id?: string;
	headNationalId: string;
	memberNationalId: string;
	registryNumber: string;
	fatherFullName: string;
	subjectFullName: string;
	caseType: string;
	caseDescription: string;
	caseDate: string; // ISO date string
	amountUsd: number;
	grantsCount: number;
	imagePath?: string | null;
}

@Injectable({ providedIn: 'root' })
export class FamilyCasesService {
	private readonly baseUrl = environment.apiBase + '/api/familycases';
	constructor(private http: HttpClient) { }

	list(): Observable<FamilyCase[]> {
		return this.http.get<FamilyCase[]>(this.baseUrl);
	}
	get(id: string): Observable<FamilyCase> {
		return this.http.get<FamilyCase>(`${this.baseUrl}/${id}`);
	}
	create(payload: FamilyCase): Observable<FamilyCase> {
		return this.http.post<FamilyCase>(this.baseUrl, payload);
	}
	update(id: string, payload: FamilyCase): Observable<void> {
		return this.http.put<void>(`${this.baseUrl}/${id}`, payload);
	}
	delete(id: string): Observable<void> {
		return this.http.delete<void>(`${this.baseUrl}/${id}`);
	}
	upload(id: string, file: File): Observable<{ imagePath?: string, ok?: boolean }> {
		const fd = new FormData();
		fd.append('file', file);
		// Node endpoint stores in DB
		return this.http.post<{ imagePath?: string, ok?: boolean }>(`${this.baseUrl}/${id}/image`, fd);
	}
	getImageBlob(id: string): Observable<Blob> {
		return this.http.get(`${this.baseUrl}/${id}/image`, { responseType: 'blob' });
	}
}


